var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsPersonOutlineBrand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Person") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Outline-v2",
    d: "M52,46.61A14.63,14.63,0,1,0,37.38,32,14.62,14.62,0,0,0,52,46.61Zm0-24.75A10.13,10.13,0,1,1,41.88,32,10.13,10.13,0,0,1,52,21.86ZM22.38,81.64H81.62A6.36,6.36,0,0,0,86.7,71.46c-6.15-8-19.38-13.61-34.7-13.61S23.45,63.41,17.3,71.46A6.36,6.36,0,0,0,22.38,81.64Zm-1.5-7.44C26.38,67,38.59,62.35,52,62.35S77.62,67,83.12,74.2a1.74,1.74,0,0,1,.18,1.89,1.84,1.84,0,0,1-1.68,1H22.38a1.84,1.84,0,0,1-1.68-1A1.74,1.74,0,0,1,20.88,74.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPersonOutlineBrand);
export default __webpack_public_path__ + "static/media/Icons_Person_Outline_brand.fec54d4fa8a590ffe50b56a0e4784f92.svg";
export { ForwardRef as ReactComponent };